import { render, staticRenderFns } from "./myWork.vue?vue&type=template&id=4ca9a389&scoped=true&"
import script from "./myWork.vue?vue&type=script&lang=ts&"
export * from "./myWork.vue?vue&type=script&lang=ts&"
import style0 from "./myWork.vue?vue&type=style&index=0&id=4ca9a389&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9a389",
  null
  
)

export default component.exports